// import logo from './logo.svg';
import './App.css';
import { useEffect, useState, useCallback  } from "react";
import socket from "./socket";
import { usePaystackPayment } from "react-paystack";


function App() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");

  // Paystack config details (TEST MODE)
  const config = {
    reference: new Date().getTime().toString(),
    email: "test@naijabites.com",
    amount: 5000 * 100, // temporary amount (will improve this later)
    publicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY
  };

  const onSuccess = (reference) => {
    socket.emit("payment-success", reference.reference);
  };

  const onClose = () => {
    alert("Payment cancelled");
  };

  const paystackInit = usePaystackPayment(config);

    const initializePayment = useCallback(() => {
      paystackInit(onSuccess, onClose);
    }, [paystackInit]);


  // const initializePayment = usePaystackPayment(config);

  useEffect(() => {
      socket.on("bot-message", (data) => {
        setMessages((prev) => [...prev, { from: "bot", text: data.text }]);
      });

      socket.on("initiate-payment", () => {
        initializePayment();
      });

      return () => {
        socket.off("bot-message");
        socket.off("initiate-payment");
      };
    }, [initializePayment]);


  const sendMessage = () => {
    if (!input.trim()) return;

    setMessages((prev) => [...prev, { from: "user", text: input }]);
    socket.emit("user-message", input);
    setInput("");
  };

  return (
    <div>
      <h2>Devor Biter Chatbot</h2>

      <div style={{ height: 400, overflowY: "auto" }}>
        {messages.map((msg, i) => (
          <p key={i}>
            <b>{msg.from}:</b> {msg.text}
          </p>
        ))}
      </div>

      <input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Enter option"
      />
      <button onClick={sendMessage}>Send</button>
    </div>
  );
}

export default App;

